<template>
  <!-- Page Title -->
  <v-flex class="fixed-bar">
    <v-row
      style="background: #feffff; height: 70px"
      class="px-8 pt-2 pb-2 fixed-bar-row"
    >
      <v-col class="py-0" cols="7" sm="8" lg="7" md="8">
        <h1 style="font-size: 24px" v-if="!isSubTiltle" class="title_text">
          {{ title }}
        </h1>
        <h2 v-if="isSubTiltle" class="title_text">{{ title }}</h2>
        <template v-if="hasBreadcrumbs">
          <Breadcrumbs />
        </template>
      </v-col>

      <permission-control :permissionName="permission">
        <v-row justify="end">
          <v-col
            class="text-right ma-auto"
            style="width: 100%; padding: 0px"
            v-if="btnCreate"
          >
            <toggle-button
              v-if="calendarView"
              v-model="isView"
              @change="goToViews"
              :value="isView"
              style="margin-right: 12px"
              :width="75"
              :labels="{ checked: 'List', unchecked: 'Calendar' }"
            ></toggle-button>
            <v-btn
              v-if="!saleVisible"
              depressed
              small
              height="32"
              class="text-white btn_blue w-100 justify-end font-weight-bold mr-4"
              @click.stop="onClickCreate"
            >
              <v-icon small class="mr-2">mdi-plus</v-icon>Create
            </v-btn>
            <v-btn
              v-if="saleVisible"
              depressed
              small
              height="32"
              class="text-white btn_blue w-100 justify-end font-weight-bold"
              @click.stop="onClickCreate"
            >
              <v-icon small class="mr-2">mdi-plus</v-icon>Sale
            </v-btn>
          </v-col>
        </v-row>
      </permission-control>

      <v-col class="text-left ma-auto" v-if="salectfilter" sm="5" md="5" lg="5">
        <v-row justify="end">
          <div class="mr-3">
            <v-select
              :items="itemsDate"
              item-text="title"
              v-model="selectedRange"
              label="Date Range"
              dense
              @input="selectItems()"
              solo
            ></v-select>
          </div>
        </v-row>
      </v-col>

      <v-col class="text-right ma-auto" v-if="backBtn" cols="5" lg="5" sm="12">
        <v-row justify="end">
          <v-btn
            v-if="changeStatus"
            depressed
            small
            height="32"
            class="w-100 mr-4 btn-chstatus font-weight-bold"
            @click="onClickChangeStatus()"
          >
            <v-icon small class="ma-2">mdi-shield-key</v-icon>Change Status
          </v-btn>

          <permission-control :permissionName="resetPasswordPermission">
            <v-btn
              v-if="resetpass"
              depressed
              small
              height="32"
              width="80"
              class="w-100 mr-2 btn-reset font-weight-bold"
              @click="resetpassword()"
              style="width: 150px; margin-right: 4px"
            >
              <v-icon small class="ma-2">mdi-shield-key</v-icon>Reset Password
            </v-btn>
          </permission-control>
          <v-btn
            color="blue darken-2"
            height="32"
            width="80"
            class="btn-white w-100 btn-back pl-1 mr-4 d-none d-sm-flex font-weight-bold"
            dark
            @click="$router.go(-1)"
          >
            <v-icon
              small
              style="text-align: center; font-weight: bold"
              class="mx-1"
              >mdi-arrow-left</v-icon
            >Back
          </v-btn>
          <v-btn
            v-if="createSale"
            depressed
            small
            height="32"
            class="w-100 mr-4 btn-chstatus font-weight-bold"
            @click="onClickCreateSale()"
          >
            <v-icon small class="ma-2">mdi-sale</v-icon>Make sale
          </v-btn>
          <v-btn
            height="32"
            v-if="printvisible"
            width="80"
            color="blue darken-2"
            dark
            @click="openPrint"
            class="btn-white w-100 btn-back pl-1 mr-4 d-none d-sm-flex"
          >
            <v-icon class="icon_small ml-4">print</v-icon>
          </v-btn>
          <!-- <v-btn
            depressed
            v-if="printvisible"
            small
            height="32"
            width="80"
            class="btn-white w-100 btn-back pl-1  mr-1 d-none d-sm-flex"
            @click="openPrint"
          >
            <v-icon class="icon_small ma-2">mdi-printer</v-icon>PRINT
          </v-btn> -->

          <permission-control :permissionName="permission">
            <v-btn
              v-if="editRoute != ''"
              depressed
              height="32"
              width="80"
              class="btn_blue w-100 pr-7 pa-0 pl-4 font-weight-bold"
              :to="editRoute"
            >
              <v-icon small class="pl-4 mr-2">mdi-pencil-outline</v-icon>EDIT
            </v-btn>
          </permission-control>
          <v-col cols="12"> </v-col>
        </v-row>
      </v-col>
      <!--  -->
    </v-row>
    <v-row>
      <v-overlay v-if="showLoading"></v-overlay>
      <v-progress-linear
        :indeterminate="false"
        :query="false"
        v-if="showLoading"
      ></v-progress-linear>
    </v-row>
  </v-flex>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    editRoute: {
      type: String,
      default: '',
    },
    resetpass: {
      type: Boolean,
      default: false,
    },
    changeStatus: {
      type: Boolean,
      default: false,
    },
    backBtn: {
      type: Boolean,
      default: false,
    },
    isSubTiltle: {
      type: Boolean,
      default: false,
    },
    hasBreadcrumbs: {
      type: Boolean,
      default: true,
    },
    createRoute: {
      type: String,
      default: '',
    },
    calendarView: {
      type: Boolean,
      default: false,
    },
    printvisible: {
      type: Boolean,
      default: false,
    },
    createSale: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    btnCreate: {
      type: Boolean,
      default: false,
    },
    saleVisible: {
      type: Boolean,
      default: false,
    },
    createPopup: {
      type: Boolean,
      default: false,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: String,
      default: '',
    },
    salectfilter: {
      type: Boolean,
      default: false,
    },
    resetPasswordPermission: {
      type: String,
      default: '',
    },
    isChangeStatusClicked: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedRange: 'Today',
    itemsDate: [
      { title: 'Today' },
      { title: 'Last 7 Days' },
      { title: 'This Month' },
      { title: 'This Year' },
    ],
  }),
  methods: {
    goToViews() {
      this.$emit('onChangeViews', this.isView);
    },
    resetpassword() {
      if (this.resetpass) {
        this.$emit('onResetPassword', true);
      }
    },
    openPrint() {
      if (this.printvisible) {
        this.$emit('openPrintmethod', true);
      }
    },
    onClickCreateSale() {
      this.$emit('onClickCreateSale', true);
    },
    onClickChangeStatus() {
      this.$emit('onClickChangeStatus', true);
    },
    onClickCreate() {
      if (this.createPopup) {
        this.$emit('onClickCreate', true);
      } else {
        this.$router.push({ path: this.createRoute });
      }
    },
    selectItems() {
      this.$emit('selectItemFilter', this.selectedRange);
    },
  },
};
</script>
<style>
.fixed-bar:not([data-scroll='0']) {
  position: sticky;
  position: -webkit-sticky;
  top: 2.8rem;
  z-index: 3;
}
.btn-reset {
  width: 180px !important;
  margin-right: 4px !important;
}

.btn-chstatus {
  padding-right: 10px !important;
}
@media only screen and (max-width: 715px) {
  .v-breadcrumbs .v-breadcrumbs__item {
    font-size: 12px !important;
  }
  .fixed-bar .v-btn.v-size--small {
    height: 20px !important;
    font-size: 9px !important;
    padding: 5px;
    margin: 0;
  }
  .fixed-bar .icon_small {
    font-size: 9px !important;
  }
  .fixed-bar .col {
    display: contents;
  }
  .fixed-bar h1 {
    font-size: 12px !important;
    padding-right: 10px;
  }
}
</style>
